import {Page} from './page';

export class MenuItem {

  name: string;
  icon: string;
  page: Page;
  location: string;
  onaySayisi: number;


  constructor(name: string, icon: string, page: Page, location: string, onaySayisi: number = 0) {
    this.name = name;
    this.icon = icon;
    this.page = page;
    this.location = location;
    this.onaySayisi = onaySayisi;
  }

}
